import clsx from 'clsx';
import React, { ReactElement } from 'react';
import NextImage from 'next/image';
import {
  makeElementClassNameFactory,
  makeRootClassName,
  StyleProps,
} from '@/utils';
import { Text } from '@/components';

export type Web3Props = StyleProps & {
  // add props here
};

const ZACHXBT_LOGO = '/images/partners/zachxbt.svg';
const ZACHXBT_HEIGHT = 50;
const ZACHXBT_WIDTH = 35;

const SCAM_SNIFFER_LOGO = '/images/partners/scam-sniffer.svg';
const SCAM_SNIFFER_HEIGHT = 50;
const SCAM_SNIFFER_WIDTH = 50;

const WALLET_GUARD_LOGO = '/images/partners/wallet-guard.svg';
const WALLET_GUARD_HEIGHT = 50;
const WALLET_GUARD_WIDTH = 90;

const BLOCKMAGE_LOGO = '/images/partners/blockmage.svg';
const BLOCKMAGE_HEIGHT = 50;
const BLOCKMAGE_WIDTH = 100;

const BITCOINWHOSWHO_LOGO = '/images/partners/BitcoinWhosWhoLogo.svg';
const BITCOINWHOSWHO_HEIGHT = 50;
const BITCOINWHOSWHO_WIDTH = 50;

const OCI_LOGO = '/images/partners/oci.svg';
const OCI_HEIGHT = 50;
const OCI_WIDTH = 50;

const INTERLOCK_LOGO = '/images/partners/interlock.svg';
const INTERLOCK_HEIGHT = 55;
const INTERLOCK_WIDTH = 55;

const PHISHFORT_LOGO = '/images/partners/phishfort.svg';
const PHISHFORT_HEIGHT = 50;
const PHISHFORT_WIDTH = 100;

const REDEFINE_LOGO = '/images/partners/redefine.svg';
const REDEFINE_HEIGHT = 50;
const REDEFINE_WIDTH = 100;

const REKTIFY_LOGO = '/images/partners/rektify.svg';
const REKTIFY_HEIGHT = 50;
const REKTIFY_WIDTH = 100;

const XREX_LOGO = '/images/partners/xrex.svg';
const XREX_HEIGHT = 50;
const XREX_WIDTH = 100;

const YAKOA_LOGO = '/images/partners/yakoa.svg';
const YAKOA_HEIGHT = 50;
const YAKOA_WIDTH = 90;

const ROOT = makeRootClassName('Web3');
const el = makeElementClassNameFactory(ROOT);

const DEFAULT_PROPS = {} as const;

function Web3(props: Web3Props): ReactElement {
  const p = { ...DEFAULT_PROPS, ...props };

  return (
    <div className={clsx(ROOT, p.className)}>
      <div className={el`box`}>
        <Text type='h4' className={el`title`}>Web3 Security Network</Text>
        <div className={el`logos`}>
          <NextImage
            src={ZACHXBT_LOGO}
            width={ZACHXBT_WIDTH}
            height={ZACHXBT_HEIGHT}
            alt="ZachXBT_LOGO logo"
            className={el`image`}
          />
          <NextImage
            src={SCAM_SNIFFER_LOGO}
            width={SCAM_SNIFFER_WIDTH}
            height={SCAM_SNIFFER_HEIGHT}
            alt="Scam Sniffer logo"
            className={el`image`}
          />
          <NextImage
            src={WALLET_GUARD_LOGO}
            width={WALLET_GUARD_WIDTH}
            height={WALLET_GUARD_HEIGHT}
            alt="Wallet Guard logo"
            className={el`image`}
          />
          <NextImage
            src={BLOCKMAGE_LOGO}
            width={BLOCKMAGE_WIDTH}
            height={BLOCKMAGE_HEIGHT}
            alt="Blockmage logo"
            className={el`image`}
          />
          <NextImage
            src={BITCOINWHOSWHO_LOGO}
            width={BITCOINWHOSWHO_WIDTH}
            height={BITCOINWHOSWHO_HEIGHT}
            alt="Scam Sniffer logo"
            className={el`image`}
          />
          <NextImage
            src={INTERLOCK_LOGO}
            width={INTERLOCK_WIDTH}
            height={INTERLOCK_HEIGHT}
            alt="Scam Sniffer logo"
            className={el`image`}
          />
          <NextImage
            src={OCI_LOGO}
            width={OCI_WIDTH}
            height={OCI_HEIGHT}
            alt="oci logo"
            className={el`image`}
          />
          <NextImage
            src={PHISHFORT_LOGO}
            width={PHISHFORT_WIDTH}
            height={PHISHFORT_HEIGHT}
            alt="PhishFort logo"
            className={el`image`}
          />
          <NextImage
            src={REDEFINE_LOGO}
            width={REDEFINE_WIDTH}
            height={REDEFINE_HEIGHT}
            alt="Redefine logo"
            className={el`image`}
          />
          <NextImage
            src={REKTIFY_LOGO}
            width={REKTIFY_WIDTH}
            height={REKTIFY_HEIGHT}
            alt="Rektify AI logo"
            className={el`image`}
          />
          <NextImage
            src={XREX_LOGO}
            width={XREX_WIDTH}
            height={XREX_HEIGHT}
            alt="Xrex logo"
            className={el`image`}
          />
          <NextImage
            src={YAKOA_LOGO}
            width={YAKOA_WIDTH}
            height={YAKOA_HEIGHT}
            alt="Yakoa logo"
            className={el`image`}
          />
        </div>
      </div>
    </div>
  );
}

export default Web3;
